<script>
	import model from "../../stores/modelStore";
	import confirmationPages from "./confirmationPages";
	import { projectSettings } from "../../config";

	import PageSection from "../../components/PageSection.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";
</script>

<PageSection>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
		</FormColumn>
	</FormRow>

	<div class="confirmation">
		{#each confirmationPages as page, i}
			<ReviewSectionHeader heading={page.confirmationHeading} routeId={page.routeId}></ReviewSectionHeader>

			<svelte:component this={page.component} disabled />
		{/each}
	</div>

	<FormRow>
		<div class="col-md-12">
			<Checkbox
				disabled
				required="true"
				checked={true}
				label="I confirm that all information provided in this section is true and correct."
				id="confirmation"></Checkbox>
		</div>
	</FormRow>
	<FormRow>
		<div class="col-md-12">	
			<Checkbox
				disabled
				checked={$model.ReceiveFurtherCommunications}
				label="I would be open to receiving information about the role of lead plaintiff and discussing it further with Shine Lawyers"
				id="receiveFurtherCommunications"></Checkbox>
		</div>
	</FormRow>
</PageSection>

<style>
	:global(.confirmation .confirmation-hide) {
		display: none;
	}

	:global(.confirmation-show) {
		display: none;
	}

	:global(.confirmation .confirmation-show) {
		display: flex;
	}

	:global(.confirmation .confirmation-show h1, .confirmation .confirmation-show h2) {
		margin-bottom: 16px;
	}

	:global(.confirmation .confirmation-box-shadow) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		box-shadow: var(--box-shadow-card);
		padding: 20px;
		margin-bottom: 26px;
	}

	:global(.confirmation input.form-control, .confirmation select.form-control) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		height: 44px;
		line-height: 18px;
		background-image: none;
	}

	:global(.confirmation textarea.form-control) {
		border: 1px solid var(--color-soft);
		background-color: var(--color-white);
		background-image: none;
	}

	:global(.confirmation .row) {
		margin-top: 16px;
	}

	:global(.confirmation .datepicker .calendar-icon) {
		display: none;
	}
</style>
